import { CHART_TYPE } from '@constants/common/chart/chartConst';
import endpoints from '@constants/configs/endpoints';
import { api, replaceParamsInStr } from '@modules/common-utils-services/axiosUtil';
import { useReducer } from 'react';

enum actions {
    DUEDATE_BY_WORKERGROUP = 'DUEDATE_BY_WORKERGROUP',
    DUEDATE_BY_USER = 'DUEDATE_BY_USER',
    DATA_ERROR = 'DATA_ERROR',
    SPINNER = 'SPINNER',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE = 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE',
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN = 'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN',
}

type Action =
    | { type: 'DUEDATE_BY_WORKERGROUP'; payload: any }
    | { type: 'DUEDATE_BY_USER'; payload: any }
    | { type: 'DATA_ERROR'; payload: undefined }
    | { type: 'DATA_ERROR'; payload: undefined }
    | { type: 'SPINNER'; payload: boolean }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP'; payload: any }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN'; payload: any }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE'; payload: any }
    | { type: 'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN'; payload: any };

function reducer(state: any, action: Action) {
    switch (action.type) {
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE:
        case actions.DUEDATE_BY_WORKERGROUP:
        case actions.DUEDATE_BY_USER:
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN:
        case actions.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN:
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP: {
            const response = action.payload;
            return {
                ...state,
                dueDateByUserData: response,
            };
        }
        case actions.DATA_ERROR:
            return { ...state, isError: true };
        case actions.SPINNER:
            return { ...state, isSpinning: action.payload };
        default:
            return state;
    }
}

const initialState = {
    dueDateByWorkGroupData: {},
    dueDateByUserData: {},

    isSpinning: false,
};

export default () => {
    const [data, dispatch] = useReducer(reducer, initialState);

    const startSpinner = () => {
        dispatch({ type: actions.SPINNER, payload: true });
    };
    const stopSpinner = () => {
        dispatch({ type: actions.SPINNER, payload: false });
    };

    const getResolvedDateReportsGroupByAssignee = async payload => {
        try {
            const postRequestBody = { assignee: '', ...payload };
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE;
            const res = await api.post(url, postRequestBody);

            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getResolvedDateReportsGroupByAssignee(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const fetchResolvedDateReportsByWorkGroup = async payload => {
        try {
            const postRequestBody = { workGroupId: '', ...payload };
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP;
            const res = await api.post(url, postRequestBody);

            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchResolvedDateReportsByWorkGroup(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown = async requestBody => {
        try {
            const postRequestBody = requestBody;
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN;
            const res = await api.post(url, postRequestBody);

            if (res?.data) {
                dispatch({
                    type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
                    payload: { ...res.data },
                });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown = async requestBody => {
        try {
            const postRequestBody = requestBody;
            const url = (endpoints.url = endpoints.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN);
            const res = await api.post(url, postRequestBody);

            if (res?.data) {
                dispatch({
                    type: actions.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
                    payload: { ...res.data },
                });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const fetchDueDateByWorkGroup = async requestBody => {
        const { activeChart, dueDate, workgroup, userId, wokGroupDueDateReport } = requestBody;

        const isDueDateChart =
            activeChart === CHART_TYPE.ACTIVATE_WORKGROUP_BY_DUEDATE ||
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE;
        const isDueDateChartByUser =
            activeChart === CHART_TYPE.ACTIVATE_DUEDATE_BY_USERS ||
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE_DRILLDOWN;
        const isStatusChart =
            activeChart === CHART_TYPE.ACTIVATE_WORKGROUP_BY_STATUS ||
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_ASSIGNEE_STATUS;
        const isStatusChartByUser = activeChart === CHART_TYPE.ACTIVATE_STATUS_BY_USERS;
        const isAssigneeStausANDDueDateChart =
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE_DRILL_DOWN_USER;
        const isAssigneeStausORDueDateChart =
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS_DRILL_DOWN_USER ||
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_ASSIGNEE_STATUS_DRILLDOWN ||
            activeChart === CHART_TYPE.DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE_DRILLDOWN;

        try {
            let url = '';
            let res: any = null;

            url = (() => {
                if (isDueDateChart || isDueDateChartByUser) return endpoints.WORKGROUP_BY_DUEDATE;
                if (isStatusChart) return endpoints.WORKGROUP_BY_STATUS;
                if (isAssigneeStausANDDueDateChart)
                    return endpoints.DUE_DATE_REPORTS_BY_WORKGROUP_OR_ASSIGNEE_TAGS_DUE_DATE;
                return endpoints.WORKGROUP_BY_USER;
            })();
            const postRequestBody = {
                dueDate: dueDate,
                wokGroupDueDateReport,
            };
            if (isDueDateChartByUser || isStatusChartByUser) {
                postRequestBody['workgroupId'] = workgroup;
            }

            if (isAssigneeStausORDueDateChart || isAssigneeStausANDDueDateChart) {
                postRequestBody['assignee'] = userId;
                postRequestBody['userId'] = userId;
            }

            const endpoint = replaceParamsInStr(url, { dueDate: dueDate, workgroup: workgroup });
            if (
                isDueDateChart ||
                isDueDateChartByUser ||
                isStatusChart ||
                isStatusChartByUser ||
                isAssigneeStausORDueDateChart ||
                isAssigneeStausANDDueDateChart
            ) {
                res = await api.post(url, postRequestBody);
            } else {
                res = await api.get<any>(endpoint);
            }

            if (res?.data) {
                dispatch({ type: actions.DUEDATE_BY_WORKERGROUP, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchDueDateByWorkGroup(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const getDueDateReportsByWorkGroupTags = async requestBody => {
        try {
            const postRequestBody = requestBody;
            const url = (endpoints.url = endpoints.DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_STATUS);
            const res = await api.post(url, postRequestBody);

            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getDueDateReportsByWorkGroupTags(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const getDueDateReportsByAssineeTags = async requestBody => {
        try {
            const postRequestBody = requestBody;
            const url = (endpoints.url = endpoints.DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS);
            const res = await api.post(url, postRequestBody);

            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getDueDateReportsByWorkGroupTags(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    const getOpenTicketReportsByTags = async requestBody => {
        try {
            const postRequestBody = requestBody;
            const url = (endpoints.url = endpoints.DUE_DATE_REPORTS_BY_WORKGROUP_OR_ASSIGNEE_TAGS_DUE_DATE);
            const res = await api.post(url, postRequestBody);

            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getDueDateReportsByWorkGroupTags(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e,
            );
        }
    };

    return {
        chartInfoData: data,
        fetchDueDateByWorkGroup,
        fetchResolvedDateReportsByWorkGroup,
        fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown,
        getResolvedDateReportsGroupByAssignee,
        getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown,
        startSpinner,
        stopSpinner,
        getDueDateReportsByWorkGroupTags,
        getDueDateReportsByAssineeTags,
        getOpenTicketReportsByTags,
    };
};
